/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './shell/shell.config';
import { ShellComponent } from './shell/shell.component';

bootstrapApplication(ShellComponent, appConfig).catch((err) =>
  console.error(err)
);
